<h2 mat-dialog-title class="tsd-title">
  <mat-icon>timer</mat-icon>
  Save time entry
</h2>

<mat-dialog-content [formGroup]="form" class="tsd-content">
  <div class="tsd-summary" *ngIf="data.label || data.elapsedLabel">
    <div class="tsd-summary-text">
      <div class="tsd-label" *ngIf="data.label">{{ data.label }}</div>
      <div class="tsd-ref" *ngIf="data.reference">{{ data.reference }}</div>
    </div>
    <span class="tsd-elapsed" *ngIf="data.elapsedLabel">{{ data.elapsedLabel }}</span>
  </div>

  <mat-form-field appearance="outline" class="tsd-field">
    <mat-label>Description</mat-label>
    <textarea matInput rows="3" formControlName="description"
              placeholder="What did you work on?"></textarea>
  </mat-form-field>

  <ng-container *ngIf="needsDepartmentService">
    <mat-form-field appearance="outline" class="tsd-field">
      <mat-label>Department</mat-label>
      <mat-select formControlName="departmentId" [disabled]="loadingDepartments"
                  (selectionChange)="onDepartmentChange($event.value)"
                  placeholder="Select a department">
        <mat-optgroup *ngFor="let g of departmentGroups" [label]="g.companyName">
          <mat-option *ngFor="let dep of g.departments" [value]="dep.id">{{ dep.name }}</mat-option>
        </mat-optgroup>
      </mat-select>
      <mat-progress-spinner matSuffix *ngIf="loadingDepartments" diameter="18" mode="indeterminate">
      </mat-progress-spinner>
    </mat-form-field>

    <mat-form-field appearance="outline" class="tsd-field">
      <mat-label>Service</mat-label>
      <mat-select formControlName="serviceId" [disabled]="!services.length"
                  placeholder="Select a service">
        <mat-option *ngFor="let s of services" [value]="s.id">{{ s.description }}</mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>

  <mat-form-field appearance="outline" class="tsd-field">
    <mat-label>Attendees</mat-label>
    <mat-select formControlName="attendees" multiple
                [disabled]="loadingUsers"
                placeholder="Add other users (a timesheet is created for each)">
      <mat-option *ngFor="let u of attendeeOptions" [value]="u.id">{{ u.name }}</mat-option>
    </mat-select>
    <mat-hint>You're added automatically. Selected users each get their own entry.</mat-hint>
    <mat-progress-spinner matSuffix *ngIf="loadingUsers" diameter="18" mode="indeterminate">
    </mat-progress-spinner>
  </mat-form-field>

  <mat-checkbox formControlName="billable" class="tsd-billable">Billable</mat-checkbox>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="save()">Stop &amp; save</button>
</mat-dialog-actions>
